/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CashDrawerBase
 */
export interface CashDrawerBaseOptional {
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerName?: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerPrinterIp?: string;
}

export interface CashDrawerBase extends CashDrawerBaseOptional {
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerName: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerPrinterIp?: string;
}

export interface CashDrawerBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerName?: string;
  cashDrawerNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerBase
   */
  cashDrawerPrinterIp?: string;
  cashDrawerPrinterIpIsSet: boolean;
}

transformDatesMap.set("CashDrawerBase", function (model: CashDrawerBase) {});

export type CashDrawerBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cashDrawerName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  cashDrawerPrinterIp: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CashDrawerBaseMeta: CashDrawerBaseMetaI = {} as CashDrawerBaseMetaI;
CashDrawerBaseMeta = typeMeta("CashDrawerBase", {
  cashDrawerName: propertyMeta(
    "cashDrawerName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  cashDrawerPrinterIp: propertyMeta(
    "cashDrawerPrinterIp",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = CashDrawerBaseMeta;

registerMeta(() => {});

export class CashDrawerBaseTracked implements CashDrawerBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cashDrawerName__I?: string = undefined;
  cashDrawerNameIsSet: boolean = false;
  set cashDrawerName(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerName__I = v;
      this.cashDrawerNameIsSet = true;
    } else {
      this.cashDrawerName__I = v || undefined;
      this.cashDrawerNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get cashDrawerName() {
    return this.cashDrawerName__I;
  }
  cashDrawerPrinterIp__I?: string = undefined;
  cashDrawerPrinterIpIsSet: boolean = false;
  set cashDrawerPrinterIp(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerPrinterIp__I = v;
      this.cashDrawerPrinterIpIsSet = true;
    } else {
      this.cashDrawerPrinterIp__I = v || undefined;
      this.cashDrawerPrinterIpIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawerPrinterIp() {
    return this.cashDrawerPrinterIp__I;
  }
  constructor(config?: CashDrawerBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CashDrawerBaseOptional,
    options?: AssignOptions,
  ): CashDrawerBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.cashDrawerName &&
      this.cashDrawerNameApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerName = config.cashDrawerName;
      if (optionsRequired.unassign) this.cashDrawerNameIsSet = false;
      else this.cashDrawerNameIsSet = true;
    }
    if (
      config.cashDrawerPrinterIp &&
      this.cashDrawerPrinterIpApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerPrinterIp = config.cashDrawerPrinterIp;
      if (optionsRequired.unassign) this.cashDrawerPrinterIpIsSet = false;
      else this.cashDrawerPrinterIpIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashDrawerBaseTrackedI {
    const cloned = {} as CashDrawerBaseTrackedI;
    if (
      this.cashDrawerNameIsSetDeep() &&
      this.cashDrawerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerNameIsSet = true;
      cloned.cashDrawerName = this.cashDrawerName;
    } else {
      //cloned.cashDrawerNameIsSet = false
    }
    if (
      this.cashDrawerPrinterIpIsSetDeep() &&
      this.cashDrawerPrinterIpApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerPrinterIpIsSet = true;
      cloned.cashDrawerPrinterIp = this.cashDrawerPrinterIp;
    } else {
      //cloned.cashDrawerPrinterIpIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashDrawerBaseTrackedI {
    if (!this.cashDrawerNameApplyFilter(filter))
      this.cashDrawerNameIsSet = false;

    if (!this.cashDrawerPrinterIpApplyFilter(filter))
      this.cashDrawerPrinterIpIsSet = false;

    return this;
  }
  cashDrawerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerBaseMeta.cashDrawerName,
      CashDrawerBaseMeta,
      this.cashDrawerName,
      this,
    );
  }
  cashDrawerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerNameIsSet && this.cashDrawerNameApplyFilter(filter))
      return true;

    return false;
  }
  cashDrawerPrinterIpApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerBaseMeta.cashDrawerPrinterIp,
      CashDrawerBaseMeta,
      this.cashDrawerPrinterIp,
      this,
    );
  }
  cashDrawerPrinterIpIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cashDrawerPrinterIpIsSet &&
      this.cashDrawerPrinterIpApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cashDrawerNameIsSetDeep(filter)) return true;
    if (this.cashDrawerPrinterIpIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
